import { RequirementConfirmTypeEnum } from "@/types/requirement"
import { useTranslation } from "react-i18next";

const useReqConfirmType = () => {
  const { t } = useTranslation();

  const getTypeName = (type: RequirementConfirmTypeEnum) => {
    let name: string = '';

    switch (type) {
      case RequirementConfirmTypeEnum.MATERIAL_CONTROL:
        name = t('requirement.material')
        break;
      case RequirementConfirmTypeEnum.COMMODITY:
        name = t('requirement.commodity')
        break;
      case RequirementConfirmTypeEnum.PROD:
        name = t('requirement.prod')
        break;
      case RequirementConfirmTypeEnum.PURCHASE:
        name = t('requirement.purchase')
        break;
      case RequirementConfirmTypeEnum.FINANCE:
        name = t('requirement.finance')
        break;
      case RequirementConfirmTypeEnum.SALE:
        name = t('requirement.sale')
        break;

      default:
        break;
    }
    return name;
  }

  return {
    getTypeName
  }
};

export default useReqConfirmType;